// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"text_responsiveContainer__1yA2V","responsiveText":"text_responsiveText__1niKV"};